import React from "react";

import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import "./index.css";
import Login from "./Pages/User/Auth/Login";
import ForgotPassword from "./Pages/User/Auth/ForgotPassword";
import CustomerManagement from "./Pages/User/CustomerManagement";
import CustomerManager from "./Pages/User/CustomerManagement/CustomerManager";
import CustomerOrdersPreview from "./Pages/User/CustomerManagement/CustomerOrdersPreview";
import Catalog from "./Pages/User/ProductCatalog/Catalog";
import CatalogPeview from "./Pages/User/ProductCatalog/Catalog/CatalogPeview";
import AddNewProduct from "./Pages/User/ProductCatalog/AddNewProduct";
import OrderDetails from "./Pages/User/OrderManagement/OrderDetails";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./services/queryClient";
import AdminManagementHome from "./Pages/User/AdminManagement/AdminManagementHome";
import ExploreRoles from "./Pages/User/AdminManagement/ExploreRoles";
import AssignRoles from "./Pages/User/AdminManagement/AssignRoles";
import SingleAdminPreview from "./Pages/User/AdminManagement/SingleAdminPreview";
import { Toaster } from "react-hot-toast";
import CreateRole from "./Pages/User/AdminManagement/CreateRole";
import CreateAdmin from "./Pages/User/AdminManagement/CreateAdmin";
import SingleRolePreview from "./Pages/User/AdminManagement/SingleRolePreview";
import ProductCategory from "./Pages/User/ProductCatalog/ProductCategory";
import Inventory from "./Pages/User/ProductCatalog/Inventory";
import BranchManagement from "./Pages/User/BranchManagement";
import BranchPreview from "./Pages/User/BranchManagement/BranchPreview";
import AuditTrail from "./Pages/User/AuditTrail";
import OrderManagement from "./Pages/User/OrderManagement";
import DiscountManagement from "./Pages/User/DiscountManagement";
import DiscountCouponManagement from "./Pages/User/DiscountManagement/DiscountCouponManagement";
import DiscountDetails from "./Pages/User/DiscountManagement/DiscountDetails";
import EditDiscountManagement from "./Pages/User/DiscountManagement/EditDiscountManagement";
import { ManualOrderManagement } from "Pages/User/OrderManagement/manual/manual-order";
import { ConfigProvider } from "antd";
import CatalogEditPage from "Pages/User/ProductCatalog/Catalog/CatalogEditPage";
import InventoryPreview from "Pages/User/ProductCatalog/Inventory/InventoryPreview";
import AddInventory from "Pages/User/ProductCatalog/Inventory/AddInventory";
import Dashboard from "Pages/User/Dashboard";
import CreditManagement from "Pages/User/CreditManagement";
import SingleCreditManagement from "Pages/User/CreditManagement/SingleCreditManagement";
import AddProductToCategory from "Pages/User/ProductCatalog/Catalog/AddProductToCategory";
import Profile from "Pages/User/Profile";
import Report from "Pages/User/Report";
import DriverOrder from "Pages/Driver/DriverOrder";
import DriverHome from "Pages/Driver/DriverHome";
import DriverNotifications from "Pages/Driver/DriverNotifications";
import DriverProfile from "Pages/Driver/DriverProfile";
import DriverOrderDetails from "Pages/Driver/DriverOrder/DriverOrderDetails";
import ChangePassword from "Pages/User/ChangePassword";
import EditRole from "Pages/User/AdminManagement/EditRole";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/product-management",
    element: <Catalog />,
  },
  {
    path: "/product-management/:id",
    element: <CatalogPeview />,
  },
  {
    path: "/product-management/:id/edit",
    element: <CatalogEditPage />,
  },
  {
    path: "/product-management/add",
    element: <AddNewProduct />,
  },
  {
    path: "/product-management/add-to-category",
    element: <AddProductToCategory />,
  },
  {
    path: "/product-management/category",
    element: <ProductCategory />,
  },
  {
    path: "/product-management/inventory",
    element: <Inventory />,
  },
  {
    path: "/product-management/inventory/:id",
    element: <InventoryPreview />,
  },
  {
    path: "/product-management/inventory/add",
    element: <AddInventory />,
  },
  {
    path: "/customer-management",
    element: <CustomerManagement />,
  },
  {
    path: "/customer-management/:id",
    element: <CustomerManager />,
  },
  {
    path: "/customer-management/:id/orders",
    element: <CustomerOrdersPreview />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/order-management",
    element: <OrderManagement />,
  },
  {
    path: "/order-management/create",
    element: <ManualOrderManagement />,
  },
  {
    path: "/order-management/:id",
    element: <OrderDetails />,
  },
  {
    path: "/credit-management",
    element: <CreditManagement />,
  },
  {
    path: "/credit-management/:id",
    element: <SingleCreditManagement />,
  },
  {
    path: "/branch-management",
    element: <BranchManagement />,
  },
  {
    path: "/branch-management/:id",
    element: <BranchPreview />,
  },
  {
    path: "/admin-management",
    element: <AdminManagementHome />,
  },
  {
    path: "/report",
    element: <Report />,
  },
  {
    path: "/admin-management/user/:id",
    element: <SingleAdminPreview />,
  },
  {
    path: "/admin-management/explore-roles",
    element: <ExploreRoles />,
  },
  {
    path: "/admin-management/explore-roles/:id",
    element: <SingleRolePreview />,
  },
  {
    path: "/admin-management/explore-roles/:id/edit",
    element: <EditRole />,
  },
  {
    path: "/admin-management/create-role",
    element: <CreateRole />,
  },
  {
    path: "/admin-management/assign-roles",
    element: <AssignRoles />,
  },
  {
    path: "/admin-management/create-admin",
    element: <CreateAdmin />,
  },
  {
    path: "/audit-trail",
    element: <AuditTrail />,
  },
  {
    path: "/change-password",
    element: <ChangePassword />,
  },
  {
    path: "/discount-management",
    element: <DiscountManagement />,
  },
  {
    path: "/discount-management/:id",
    element: <DiscountDetails />,
  },
  {
    path: "/discount-management/create",
    element: <DiscountCouponManagement />,
  },
  {
    path: "/discount-management/edit/:id",
    element: <EditDiscountManagement />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/driver/home",
    element: <DriverHome />,
  },
  {
    path: "/driver/orders",
    element: <DriverOrder />,
  },
  {
    path: "/driver/orders/:id",
    element: <DriverOrderDetails />,
  },
  {
    path: "/driver/notifications",
    element: <DriverNotifications />,
  },
  {
    path: "/driver/profile",
    element: <DriverProfile />,
  },
  { path: "*", element: <p>ERROR - PAGE NOT AVAILABLE</p> },
]);

root.render(
  <React.StrictMode>
    <Toaster
      position="top-center"
      reverseOrder={false}
      gutter={8}
      containerClassName=""
      containerStyle={{}}
      toastOptions={{
        duration: 5000,
        style: {
          background: "#363636",
          color: "#fff",
        },
        success: {
          duration: 3000,
        },
      }}
    />
    <QueryClientProvider client={queryClient}>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#FF5001",
          },
        }}
      >
        <RouterProvider router={router} />
      </ConfigProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
